/* eslint-disable sonarjs/redundant-type-aliases */
import isObject from 'lodash/isObject';

export type UUID = string;
export type ISODate = string;
export type ISODateTime = string;

export type GQLExtensionErrors = { errors?: { message: string }[] };

export function isGQLExtensionErrors(extensions: unknown): extensions is GQLExtensionErrors {
  return (
    isObject(extensions) &&
    'errors' in extensions &&
    Array.isArray(extensions.errors) &&
    extensions.errors.every(
      e =>
        isObject(e) && 'message' in e && typeof (e as Record<string, unknown>).message === 'string'
    )
  );
}
